import { Component, HostListener, OnInit } from '@angular/core';

@Component({
  selector: 'eng-sliding-gallery',
  imports: [],
  templateUrl: './sliding-gallery.component.html',
  styleUrl: './sliding-gallery.component.scss',
})
export class SlidingGalleryComponent implements OnInit {
  private _animationInterval?: any;
  private _minCoverageHeight = 0;
  private _minCoverageWidth = 0;
  //This is always false for now, disabled due to disorienting motion.
  private _shouldAnimate = false;

  private _images: SlidingGalleryImage[] = [
    {
      url: '/images/Services_Animation_ScreenStars_02.jpg',
      width: 533,
    },
    {
      url: '/images/Services_Animation_NavisAfter_02.jpg',
      width: 723,
    },
    {
      url: '/images/iron-bridge-project_downsized.jpg',
      width: 533,
    },
    {
      url: '/images/02 Wodgina Dump Truck.jpg',
      width: 533,
    },
    {
      url: '/images/animated_conveyor_headchute.jpg',
      width: 533,
    },
    {
      url: '/images/McArthur-River-Mine-Phase-3-72-lower-res.jpg',
      width: 450,
    },
    {
      url: '/images/DJI_0188_edit_perspective_fix.jpg',
      width: 448,
    },
    {
      url: '/images/MRL_HopeDowns_StillRender_04_v01.jpg',
      width: 533,
    },
    {
      url: '/images/Jimblebar_StillRender_v02_0006.jpg',
      width: 533,
    },
    {
      url: '/images/Mesa_A_v02.jpg',
      width: 212,
    },
    {
      url: '/images/Services_Animation_NavisBefore_02.jpg',
      width: 720,
    },
  ];

  public rowHeight = 300;
  public trigger = '';
  public rows: SlidingGalleryRow[] = [];

  @HostListener('window:resize', ['$event'])
  public onResize(event: Event) {
    if (window.innerHeight > this._minCoverageHeight || window.innerWidth > this._minCoverageWidth) {
      this.fillRows();
    }
  }

  public ngOnInit(): void {
    this.fillRows();
  }

  private fillRows() {
    this.rows = [];
    this._minCoverageHeight = 0;
    this._minCoverageWidth = 0;

    let accumulatedHeight = 0;
    const targetHeight = window.innerHeight;
    while (accumulatedHeight < targetHeight) {
      this.rows.push({
        images: this.fillImages(Math.ceil(Math.random() * this._images.length)),
        class: this.rows.length % 2 === 0 ? 'move-left' : 'move-right',
      });

      accumulatedHeight += this.rowHeight;
    }

    this._minCoverageHeight = accumulatedHeight;
    this.triggerAnimation();
  }

  private triggerAnimation() {
    if (!this._shouldAnimate) {
      return;
    }

    //This should be set to the same time as the transition CSS time so that once it finishes transition
    // we start again.
    const resetTime = 900_000;

    if (this._animationInterval) {
      clearInterval(this._animationInterval);
    }

    const toggleTrigger = () => {
      this.trigger = '';
      setTimeout(() => {
        this.trigger = 'animate';
      }, 1000);
    };

    toggleTrigger();
    this._animationInterval = setInterval(toggleTrigger, resetTime);
  }

  private fillImages(seed: number): SlidingGalleryImage[] {
    let images: SlidingGalleryImage[] = [];
    let accumulatedWidth = 0;
    const targetWidth = window.innerWidth;

    let i = seed;
    while (accumulatedWidth < targetWidth) {
      let index = i % (this._images.length - 1);
      let image = this._images[index];
      images.push(image);
      accumulatedWidth += image.width;
      i += 1;
    }

    images = [...images, ...images, ...images];

    if (!this._minCoverageWidth || accumulatedWidth < this._minCoverageWidth) {
      this._minCoverageWidth = accumulatedWidth;
    }

    return images;
  }
}

export interface SlidingGalleryImage {
  url: string;
  width: number;
}

export interface SlidingGalleryRow {
  class: string;
  images: SlidingGalleryImage[];
}
